import React from 'react';
import { Link } from 'react-router-dom';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import { IoMdArrowBack } from 'react-icons/io';
import { MdOutlineAdd } from 'react-icons/md';
import { useTranslation } from 'react-i18next';

interface SuccessModalProps {
  isOpen: boolean;
  onClose: () => void;
  goBackTo: string;
  addAnotherTo: string;
  goBackLabel?: string;
  addAnotherLabel?: string;
  iconSize?: string;
  onGoBack?: () => void;
  onAddAnother?: () => void;
  iconClassName?: string;
  title?: string;
}

const SuccessModal: React.FC<SuccessModalProps> = ({
  isOpen,
  onClose,
  goBackTo,
  addAnotherTo,
  goBackLabel,
  addAnotherLabel,
  iconSize = '20px',
  onGoBack,
  onAddAnother,
  iconClassName = 'mdi mdi-check-circle-outline display-4 text-success',
  title,
}) => {
  const { t } = useTranslation();

  return (
    <Modal
      isOpen={isOpen}
      toggle={onClose}
      backdrop="static"
      centered
      id="success-backdrop"
    >
      <ModalHeader className="d-flex align-items-center justify-content-between" />
      <ModalBody className="text-center p-5">
        <i className={iconClassName}></i>
        <div className="mt-4">
          <h4 className="mb-3">{title ?? t('Successfully')}</h4>
          <br />
          <div
            className="gap-2 justify-content-center align-items-center"
            style={{ display: 'flex', flexDirection: 'column' }}
          >
            <Link
              data-testid="go_back_to_items_test"
              to={goBackTo}
              className="btn btn-light material-shadow-none"
              style={{ width: '50%' }}
              onClick={() => {
                onClose();
                onGoBack?.();
              }}
            >
              <IoMdArrowBack className="me-1 align-bottom" size={iconSize} />
              {goBackLabel ?? t('Go back')}
            </Link>

            <Link
              data-testid="add_another_test"
              to={addAnotherTo}
              className="btn btn-success material-shadow-none"
              style={{ width: '50%' }}
              onClick={() => {
                onClose();
                onAddAnother?.();
              }}
            >
              <MdOutlineAdd className="me-1 align-bottom" size={iconSize} />
              {addAnotherLabel ?? t('Btn_Add_Another')}
            </Link>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default SuccessModal;
